export const investmentAmounts = [
  { label: '0 - 25000', value: '0 - 25000' },
  { label: '25000 - 100000', value: '25000 - 100000' },
  { label: '100000 or more', value: '100000 or more' }
]
